<div class="tabs-wrapper" *ngIf="tabs">

    <div class="tab" *ngFor="let t of tabs, let i = index" [ngClass]="{'active': activeTab === t.label.toLowerCase(), 'first': i === 0, 'last': i === tabs.length - 1 }" (click)="onClickTab(t)">
        <div class="tab-content">
            <div class="tab-icon" [ngClass]="{'active': activeTab === t.label.toLowerCase()}">
                <div class="tab-indicator" *ngIf="t?.showIndicator"></div>
                <app-svg-loader [height]="t.iconSize" [url]="t.iconURL"></app-svg-loader>
            </div>
            <div class="tab-label" [ngClass]="{'active': activeTab === t.label.toLowerCase()}">{{t.label}}</div>
        </div>
    </div>

</div>
